/**
 * ETD role codes used for access control throughout the application.
 * Frontend role checks are for UX only — real authorization is enforced by the backend.
 */

export const ETD_ROLES = {
  ASSESSOR: "ETD_assessor",
  APPROVAL: "ETD_Approval",
  MANAGER: "ETD_Manager",
  ADMINISTRATOR: "ETD_administrator",
  STATION_ADMIN: "ETD_STATION_ADMIN",
};

/** Roles that are allowed to access the ETD system. */
export const ALLOWED_ETD_ROLES = Object.values(ETD_ROLES);

/** Role IDs considered to have admin privileges (for MainDashboard). */
export const ADMIN_ROLE_IDS = [1, 2];

/**
 * Page guard keys (previously Swahili-named, now documented).
 * Used by RouteGuard to determine which roles can access a page.
 */
export const PAGE_GUARDS = {
  MAIN_DASHBOARD: "MbaoKuu",
  ETD_DASHBOARD: "MbaoNdogo",
  ASSESSMENT: "Uchambuzi",
  APPROVAL: "Mwamuzi",
  MANAGER: "Meneja",
  UNLOCK_APPLICATION: "FunguaOmbi",
  UNLOCK_DOCUMENT: "FunguaNyaraka",
  ENQUIRY: "Maulizo",
  REPORTS_ADMIN: "Mwamba",
};
